import { render } from "./EsimProfilesTable.vue?vue&type=template&id=68be931f&ts=true"
import script from "./EsimProfilesTable.vue?vue&type=script&lang=ts"
export * from "./EsimProfilesTable.vue?vue&type=script&lang=ts"

import "./EsimProfilesTable.vue?vue&type=style&index=0&id=68be931f&lang=scss"

import exportComponent from "C:\\Bohdan\\telesim_test\\telesim-admin-panel\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__